"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
let CategoryTag = class CategoryTag extends vue_property_decorator_1.Vue {
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], CategoryTag.prototype, "category", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: 0 })
], CategoryTag.prototype, "starValue", void 0);
CategoryTag = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Zap: lucide_vue_next_1.Zap,
            Rating: bmk_ui_framework_1.Rating,
        },
    })
], CategoryTag);
exports.default = CategoryTag;
